import GIFWorkerJS from '@heriec/simple-gif/worker?url';
import {
  SimpleGif,
  type UnencodedFrame,
  type DecodedFrame,
  type TransformArgs,
  type ProgressFunction,
  decode,
  type Gif,
} from '@heriec/simple-gif';
import store from '~/store';

export interface GifEncodeOption {
  width: number;
  height: number;
  maxColors: number;
  frames: UnencodedFrame[];
  transformArgs?: TransformArgs;
}

export interface GifDecodeResult {
  width: number;
  height: number;
  frames: DecodedFrame[];
}

export const useGifStore = defineStore('gif', () => {
  const simpleGif = new SimpleGif({
    workerUrl: GIFWorkerJS as any,
    debug: false,
  });

  const createGif = async (options: GifEncodeOption, progress?: ProgressFunction) => {
    return new Promise<Blob>((resolve, reject) => {
      const startTime = performance.now();
      simpleGif.encode({
        width: options.width,
        height: options.height,
        maxColors: options.maxColors,
        premultipliedAlpha: true,
        frames: options.frames,
        transformArgs: options.transformArgs,
        format: 'blob',
        progress,
        error: (e) => {
          if (e.message.includes('Out of memory')) {
            toast.error(`生成GIF失败，您的浏览器内存不足，生成体积过大，请减少帧数或者尺寸`, {
              position: 'top-center',
              closeButton: false,
            });
          }
          reject(e);
        },
        complete: (blob: any) => {
          console.log('encoding to gif', performance.now() - startTime);
          resolve(blob);
        },
      });
    });
  };

  const decodeGif = async (gifUrl: string, progress?: ProgressFunction) => {
    return new Promise<GifDecodeResult>(async (resolve, reject) => {
      const startTime = performance.now();
      const buffer = await fetch(gifUrl).then((res) => res.arrayBuffer());
      let gif: Gif;
      try {
        gif = decode(buffer);
      } catch (e) {
        toast.error('GIF解码支持主流87a/89a格式！您的GIF格式没见过！', {
          position: 'top-center',
          closeButton: false,
        });
        reject(e);
      }
      simpleGif.decodeFrames({
        source: buffer,
        progress,
        error: (e) => {
          reject(e);
        },
        complete: (frames: DecodedFrame[]) => {
          console.log('encoding to gif', performance.now() - startTime);
          resolve({
            width: gif.width,
            height: gif.height,
            frames,
          });
        },
      });
    });
  };

  const terminal = () => {
    simpleGif.stopWorker();
  };

  return { simpleGif, createGif, decodeGif, terminal };
});

/** 在 setup 外使用 */
export function useGifStoreHook() {
  return useGifStore(store);
}
